module.exports = __webpack_public_path__ + "img/whiteflower.a30b2022.svg";